<mat-form-field class="w-100">
    <mat-label>Company ID</mat-label>    
    <input matInput name="id" [formControl]="$any(searchCompanyForm.get('company_id'))" [matAutocomplete]="companyAuto"
        (input)="onCompanyInput($any($event.target).value)"
        (keyup.enter)="triggerCompanySearch(searchCompanyForm.get('company_id')?.value ?? '')" required
        autocomplete="id" />
    <button mat-icon-button matSuffix type="button" aria-label="Search companies"
        (click)="triggerCompanySearch(searchCompanyForm.get('company_id')?.value ?? '')">
        @if (!searchLoading) {
        <mat-icon>search</mat-icon>
        }@else{
        <mat-progress-spinner class="small-spinner bright-spinner" mode="indeterminate"></mat-progress-spinner>
        }

    </button>
    <mat-autocomplete #companyAuto="matAutocomplete" autoActiveFirstOption (optionSelected)="safeCallback()">
        <mat-option *ngFor="let opt of companyOptions; trackBy: trackByCompany" [value]="opt.id">
            {{ opt.id }} — {{ opt.name }}
        </mat-option>
    </mat-autocomplete>
    <mat-error>ID is required.</mat-error>
</mat-form-field>
